import { Jurisdiction } from '@gig/magic-jurisdictions';
import { USER_JURISDICTION_QUERY } from '@gig/magic-messages';

export async function getUserJurisdiction() {
    return await window.queryBus.query<Jurisdiction>(USER_JURISDICTION_QUERY)!;
}
